import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { useFormik } from "formik";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import { createBancoFormValidate } from "../../../../helper/validate";

const AddressView = forwardRef(({ item, callNewEditModal }, ref) => {
  useEffect(() => {
    formik?.resetForm();
  }, [item]);

  let initialValues = {
    isNew: true,
    id: 0,
    nombre: "",
    alias: "",
    cuenta: "",
  };

  if (item && Object.keys(item).length > 0) {
    initialValues = {
      id: item.id,
      nombre: item.nombre,
      alias: item.alias,
      cuenta: item.cuenta,
    };
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: createBancoFormValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      console.log("dddd");
    },
  });

  // used useImperativeHandle here
  useImperativeHandle(ref, () => ({
    clear: () => {
      formik.resetForm();
    },
    getValues: () => {
      const values = formik.values;
      if (values.isNew) {
        values.id = Date.parse(Date());
      }
      return values; //"internalRef.current.value";
    },
    validate: () => {
      const isValid = formik.values.nombre.length > 0;
      formik.handleSubmit();
      return isValid;
    },
  }));

  /*  useEffect(() => {
    return () => {
      callNewEditModal(formik.values);
    };
  }, []);*/

  return (
    <div className="">
      <div className="row">
        <div className="col">
          <label htmlFor="exampleInputEmail1" className="form-label">
            Nombre
          </label>
          <input
            {...formik.getFieldProps("nombre")}
            {...formikExtra.upperCase("nombre", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.nombre)}`}
            id="validationEmail"
            aria-describedby="emailHelp777"
          />
          <div className="valid-feedback"></div>
          <div className="invalid-feedback">{formik.errors.nombre}</div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <label htmlFor="exampleInputAlias1" className="form-label">
            Alias
          </label>
          <input
            {...formik.getFieldProps("alias")}
            {...formikExtra.upperCase("alias", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.alias)}`}
            id="validationAlias"
            aria-describedby="emailHelp777"
          />
          <div className="valid-feedback"></div>
          <div className="invalid-feedback">{formik.errors.alias}</div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <label htmlFor="exampleInputColonia" className="form-label">
            Cuenta
          </label>
          <input
            {...formik.getFieldProps("cuenta")}
            {...formikExtra.upperCase("cuenta", formik)}
            type="text"
            className={`form-control ${invalidClass(formik.errors.cuenta)}`}
            id="validationCuenta"
            aria-describedby="cuentaHelp777"
          />
          <div className="valid-feedback"></div>
          <div className="invalid-feedback">{formik.errors.cuenta}</div>
        </div>
      </div>
    </div>
  );
});

export default AddressView;
